import React, { useState, useEffect } from "react";
import { Table, Button, Form, Modal, Row, Col, Alert } from "react-bootstrap";
import './categoriescss/UserCategories.css';
import axios from 'axios';
import Breadcrumb from "app/components/Breadcrumb";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useTranslations from '../transalation/TranslationUtils';
import { useDispatch } from "react-redux";
import { createCampaignType, createVenue, getCampaignTypeList, initMainSimpleData, setMainSimpleData, updateCampaignType, updateVenue } from "app/redux/slices/rdxMainSlice";
import { useSelector } from "react-redux";
import { DEFAULT_IP } from "app/utils/constant";

const UserCategories = () => {
    const { func_t, role_edit, role_Add, role_delete,
        role_next, role_previous, usercateg, usersearch,
        usertype, descCh, venuech, incenter,
        campaignTypeMngmnt, campaignVenueMngmnt, showErrMsg, showSuccessMsg } = useTranslations();

    const dispatch = useDispatch();
    const editCmpgnCat = useSelector((state) => state.rdxMain?.editCmpgnCat || {});
    const editCmpgnVenue = useSelector((state) => state.rdxMain?.editCmpgnVenue || {});
    const data = useSelector((state) => state.rdxMain?.campaignTypeList || []);
    const [selectedOption, setSelectedOption] = useState("campaignType");
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [successMessage, setSuccessMessage] = useState("");
    const [totalPagest, setTotalPagest] = useState(1);
    const totalPagestype = Math.ceil(data.length / itemsPerPage);
    const paginatedTypes = data.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const [venuedata, setvenuedataData] = useState([]);
    const totalPages = Math.ceil(venuedata.length / itemsPerPage);
    const paginatedVenues = venuedata.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    useEffect(() => {
        fetchCampaignVenues();
    }, []);

    useEffect(() => {
        if (data) {
            setTotalPagest(Math.ceil(data.length / itemsPerPage));  // Set totalPages based on fetched data
        }
    }, [data]);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const fetchCampaignVenues = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(DEFAULT_IP + "/webapp/memportal/getvenuelist", {
                headers: {
                    "Content-Type": "application/json",
                    Token: token,
                },
            });

            // Log the raw response
            console.log("Raw response:", response.data);

            if (response.data.code === 1) {
                // Directly access response.data.data which is an array
                const venuesData = response.data.data || [];

                // Log parsed data
                console.log("Parsed venues data:", venuesData);

                setvenuedataData(venuesData);
            } else {
                console.error("API responded with an error:", response.data.message_en);
            }
        } catch (error) {
            console.error("Error fetching campaign venues:", error);
        }
    };


    // Event handler to update selected option
    const handleSelectionChange = (e) => {
        setSelectedOption(e.target.value);
    };

    // Function to toggle the modal
    const handleModalShow = () => setShowModal(true);
    const handleModalClose = () => {
        setShowModal(false);
    };

    // Handle input change for all input fields
    const handleCmpgnCatChange = (e, path) => {
        const { value } = e.target;

        let data = {
            data: value,
            projection: "editCmpgnCat",
            path: path
        }
        dispatch(setMainSimpleData(data));
    };

    const handleCmpgnVenueChange = (e, path) => {
        const { value } = e.target;

        let data = {
            data: value,
            projection: "editCmpgnVenue",
            path: path
        }
        dispatch(setMainSimpleData(data));
    };

    // Handle form submit post apis
    const handleFormSubmit = async () => {
        switch (selectedOption) {
            case "campaignType":
                let typeCallback = (isSuccess, data) => {
                    if (isSuccess) {
                        setSuccessMessage(showSuccessMsg(data));
                        dispatch(getCampaignTypeList());
                        handleModalClose();
                    } else {
                        alert(showErrMsg(data));
                    }
                }

                if (editCmpgnCat.campaign_type_id) {
                    dispatch(updateCampaignType(editCmpgnCat, typeCallback));
                } else {
                    dispatch(createCampaignType(editCmpgnCat, typeCallback));
                }
                break;
            case "campaignVenue":
                let venueCallback = (isSuccess, data) => {
                    if (isSuccess) {
                        setSuccessMessage(showSuccessMsg(data));
                        fetchCampaignVenues();
                        handleModalClose();
                    } else {
                        alert(showErrMsg(data));
                    }
                }

                if (editCmpgnVenue.venue_id) {
                    dispatch(updateVenue(editCmpgnVenue, venueCallback));
                } else {
                    dispatch(createVenue(editCmpgnVenue, venueCallback));
                }
                break;
            default:
                alert("Please select a valid option");
                return;
        }
    };

    const onAddTypeClick = () => {
        if ("campaignType" == selectedOption) {
            let data = {
                data: {},
                projection: "editCmpgnCat",
                type: "obj"
            };
            dispatch(initMainSimpleData(data));
            handleModalShow();
        } else if ("campaignVenue" == selectedOption) {
            let data = {
                data: {},
                projection: "editCmpgnVenue",
                type: "obj"
            };
            dispatch(initMainSimpleData(data));
            handleModalShow();
        }
    }

    const onEditTypeClick = (item) => {
        if ("campaignType" == selectedOption) {
            let data = {
                data: item,
                projection: "editCmpgnCat",
                type: "obj"
            };
            dispatch(initMainSimpleData(data));
            handleModalShow();
        } else if ("campaignVenue" == selectedOption) {
            let data = {
                data: item,
                projection: "editCmpgnVenue",
                type: "obj"
            };
            dispatch(initMainSimpleData(data));
            handleModalShow();
        }
    }


    const handleDeleteType = async (item) => {
        const confirmed = window.confirm(`Are you sure you want to delete Campaign Type ${item.campaign_type_code}?`);
        if (!confirmed) {
            return;
        }

        try {
            const token = localStorage.getItem("authToken");

            const response = await axios.post(
                DEFAULT_IP + "/webapp/memportal/deletecampaigntype",
                {
                    campaign_type_id: item.campaign_type_id,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Token: token,
                    }
                }
            );

            if (response.data.code === 1) {
                alert(`Campaign Type: ${item.campaign_type_code} deleted successfully!`);

                // Fetch updated data after deletion
                dispatch(getCampaignTypeList());

                // Adjust pagination if necessary
                if (currentPage > totalPagest && totalPagest > 1) {
                    setCurrentPage(totalPages);  // Go to last page if current page exceeds total pages
                } else {
                    setCurrentPage(1);  // If current page is empty, reset to the first page
                }
            } else {
                console.error("Failed to delete campaign type:", response.data.message_en);
                alert("Failed to delete campaign type. Please try again.");
            }
        } catch (error) {
            console.error("Error deleting campaign type:", error);
            toast.error("An error occurred while deleting the campaign type. Please try again.");
        }
    };

    const handleDeleteVenue = async (item) => {
        const confirmed = window.confirm(`Are you sure you want to delete Venue ${item.venue_name.zh}?`);
        if (!confirmed) {
            return;
        }
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.post(
                DEFAULT_IP + "/webapp/memportal/deletevenue",
                {
                    venue_id: item.venue_id,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Token: token,
                    }
                }
            );
            console.log("[DELETE_VENUE]: Venue deleted successfully");
            if (response.data.code === 1) {
                alert(`Campaign Venue :- ${item.venue_name.en}  deleted successfully!`);
                fetchCampaignVenues();
            } else {
                alert(`Failed to delete venue: ${response.data.message_en || "Unknown error"}`);
            }
        } catch (error) {
            console.error("Error deleting venue:", error);
            alert("An error occurred while deleting the venue. Please try again.");
        }
    };

    // Render modal content dynamically based on the selected option
    const renderModalContent = () => {
        switch (selectedOption) {
            case "campaignType":
                return (
                    <>
                        <p className="usercategoriesformhead">{(editCmpgnCat.campaign_type_id) ? 'Edit' : 'Add New'} Campaign Type</p>
                        <Form.Group controlId="formInput1" className="floating-label-group">
                            <Form.Control
                                type="text"
                                name="input1"
                                value={editCmpgnCat.campaign_type_code}
                                onChange={(event) => handleCmpgnCatChange(event, "editCmpgnCat.campaign_type_code")}
                                className="floating-input"
                            />
                            <Form.Label className="floating-label">Type</Form.Label>
                        </Form.Group>
                        <Form.Group controlId="formInput2" className="floating-label-group mt-3">
                            <Form.Control
                                type="text"
                                name="input2"
                                value={editCmpgnCat.campaign_type_name?.zh}
                                onChange={(event) => handleCmpgnCatChange(event, "editCmpgnCat.campaign_type_name.zh")}
                                className="floating-input"
                            />
                            <Form.Label className="floating-label">Description (Chinese)</Form.Label>
                        </Form.Group>
                        <Form.Group controlId="formInput3" className="floating-label-group mt-3">
                            <Form.Control
                                type="text"
                                name="input3"
                                value={editCmpgnCat.campaign_type_name?.en}
                                onChange={(event) => handleCmpgnCatChange(event, "editCmpgnCat.campaign_type_name.en")}
                                className="floating-input"
                            />
                            <Form.Label className="floating-label">Description (English)</Form.Label>
                        </Form.Group>
                    </>
                );
            case "campaignVenue":
                return (
                    <>
                        <p className="usercategoriesformhead">{(editCmpgnVenue.venue_id) ? 'Edit' : 'Add New'}  Campaign Venue</p>

                        <Form.Group controlId="formInput1" className="floating-label-group">
                            <Form.Select
                                name="input4"
                                value={editCmpgnVenue.in_centre}
                                onChange={(event) => handleCmpgnVenueChange(event, "editCmpgnVenue.in_centre")}
                                className="floating-input"
                            >
                                <option value="Y">Y</option>
                                <option value="N">N</option>
                            </Form.Select>
                            <Form.Label className="floating-label">In-Centre (YTNEC)</Form.Label>
                        </Form.Group>

                        <Form.Group controlId="formInput2" className="floating-label-group mt-3">
                            <Form.Control
                                type="text"
                                name="input5"
                                value={editCmpgnVenue.venue_name?.zh}
                                onChange={(event) => handleCmpgnVenueChange(event, "editCmpgnVenue.venue_name.zh")}
                                className="floating-input"
                            />
                            <Form.Label className="floating-label">Venue (Chinese)</Form.Label>
                        </Form.Group>
                        <Form.Group controlId="formInput3" className="floating-label-group mt-3">
                            <Form.Control
                                type="text"
                                name="input6"
                                value={editCmpgnVenue.venue_name?.en}
                                onChange={(event) => handleCmpgnVenueChange(event, "editCmpgnVenue.venue_name.en")}
                                className="floating-input"
                            />
                            <Form.Label className="floating-label">Venue (English)</Form.Label>
                        </Form.Group>
                    </>
                );

            default:
                return <p>Please select a campaign management option.</p>;
        }
    };

    return (
        <div className="container-fluid mt-4 pt-3 ps-4">

            <div className="breadcrumb">
                <Breadcrumb routeSegments={[{ name: usercateg() }]} />
            </div>
            {successMessage && (
                <Alert
                    variant="success"
                    onClose={() => setSuccessMessage("")}
                    dismissible
                >
                    {successMessage}
                </Alert>
            )}
            <Row>
                <Col md={12}>
                    <div className="mb-4">
                        <p className="usercategorieshead">{usercateg()}</p>
                        <Form.Group controlId="campaignManagementForm" className="d-flex align-items-center">
                            <Form.Label className="me-2" style={{ "marginBottom": "0px" }}>{usersearch()}</Form.Label>
                            <Form.Select
                                value={selectedOption}
                                onChange={handleSelectionChange}
                                className="custom-select me-2"
                            >
                                <option value="campaignType">{campaignTypeMngmnt()}</option>
                                <option value="campaignVenue">{campaignVenueMngmnt()}</option>

                            </Form.Select>
                            <Button onClick={() => onAddTypeClick()} className="useraddbtn me-2 ">
                                {role_Add()}
                            </Button>
                        </Form.Group>
                    </div>
                </Col>
            </Row>

            <Row className="mt-4">
                {selectedOption === "campaignType" && (
                    <Col md={12}>
                        <div className="table-responsive">
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th className="custom-th">{usertype()}</th>
                                        <th className="custom-th">{descCh()}</th>
                                        <th className="custom-th">Description(English)</th>
                                        <th className="custom-th text-end "> <div className=" d-flex justify-content-end align-items-end pe-5">{func_t()}</div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No data available
                                            </td>
                                        </tr>
                                    ) : (
                                        paginatedTypes.map((item, index) => (
                                            <tr key={index}>
                                                <td className="custom-td">{item.campaign_type_code}</td>
                                                <td className="custom-td">{item.campaign_type_name?.zh}</td>
                                                <td className="custom-td">{item.campaign_type_name?.en}</td>
                                                <td className="custom-td text-end">
                                                    <Button className="me-2 useraddbtnbtn" onClick={() => onEditTypeClick(item)}>{role_edit()}</Button>
                                                    <Button className="userdelete" onClick={() => handleDeleteType(item)}>{role_delete()}</Button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>


                        </div>


                        <nav aria-label="Page navigation example" className="mt-5">
                            <ul className="pagination justify-content-end">
                                {/* Previous Button */}
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                        className={`page-link ${currentPage !== 1 ? 'text-success' : ''}`}
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        {role_previous()}
                                    </button>
                                </li>

                                {/* Page Numbers */}
                                {Array.from({ length: totalPagestype }, (_, i) => i + 1).map((page) => (
                                    <li
                                        key={page}
                                        className={`page-item ${page === currentPage ? 'active' : ''}`}
                                    >
                                        <button
                                            className={`page-link ${page === currentPage ? 'bg-success text-white' : 'text-success'}`}
                                            onClick={() => handlePageChange(page)}
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}

                                {/* Next Button */}
                                <li className={`page-item ${currentPage === totalPagestype ? 'disabled' : ''}`}>
                                    <button
                                        className={`page-link ${currentPage !== totalPagestype ? 'text-success' : ''}`}
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPagestype}
                                    >
                                        {role_next()}
                                    </button>
                                </li>
                            </ul>
                        </nav>


                    </Col>
                )}

                {selectedOption === "campaignVenue" && (
                    <Col md={12}>
                        <div className="table-responsive">
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th className="custom-th">{incenter()} (YTNEC)</th>
                                        <th className="custom-th">{venuech()}</th>
                                        <th className="custom-th">Venue (English)</th>
                                        <th className="custom-th text-end"> <div className=" d-flex justify-content-end align-items-end pe-5">{func_t()}</div></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {venuedata.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No venues available
                                            </td>
                                        </tr>
                                    ) : (
                                        paginatedVenues.map((item, index) => (
                                            <tr key={index}>
                                                <td className="custom-td">{item.in_centre}</td>
                                                <td className="custom-td">{item.venue_name?.zh}</td>
                                                <td className="custom-td">{item.venue_name?.en}</td>
                                                <td className="custom-td text-end">
                                                    <Button className="me-2 useraddbtnbtn" onClick={() => onEditTypeClick(item)}>{role_edit()}</Button>
                                                    <Button
                                                        className="userdelete"
                                                        onClick={() => handleDeleteVenue(item)}
                                                    >{role_delete()}</Button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>

                            </Table>
                        </div>


                        <nav aria-label="Page navigation example" className="mt-5">
                            <ul className="pagination justify-content-end">
                                {/* Previous Button */}
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                        className={`page-link ${currentPage !== 1 ? 'text-success' : ''}`}
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        {role_previous()}
                                    </button>
                                </li>

                                {/* Page Numbers */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                    <li
                                        key={page}
                                        className={`page-item ${page === currentPage ? 'active' : ''}`}
                                    >
                                        <button
                                            className={`page-link ${page === currentPage ? 'bg-success text-white' : 'text-success'}`}
                                            onClick={() => handlePageChange(page)}
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}

                                {/* Next Button */}
                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button
                                        className={`page-link ${currentPage !== totalPages ? 'text-success' : ''}`}
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        {role_next()}
                                    </button>
                                </li>
                            </ul>
                        </nav>

                    </Col>
                )}

            </Row>


            <ToastContainer />

            {/* Modal for Adding New Item */}
            <Modal show={showModal} onHide={handleModalClose} centered>
                <Modal.Body>
                    <Form>{renderModalContent()}</Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleModalClose} className="userformcansle">
                        Cancel
                    </Button>
                    <Button onClick={handleFormSubmit} className="userformsave">
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default UserCategories;
